// client/src/components/LoginPage.jsx
import { useState } from 'react';
import { LOGO_HORIZONTAL_BLACK, LOGO_HORIZONTAL_WHITE } from '../logo';
import { api } from '../api';

export default function LoginPage({ onLogin, onForgotPassword }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await api.login(email, password);
      localStorage.setItem('ipe_token', res.token);
      localStorage.setItem('ipe_user', JSON.stringify(res.user));
      onLogin(res.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Login page always has dark background — always use white logo
  const isDark = true;

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div style={{ width: 400, background: '#1e293b', borderRadius: 16, padding: 40, boxShadow: '0 24px 64px rgba(0,0,0,0.5)' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src={isDark ? LOGO_HORIZONTAL_WHITE : LOGO_HORIZONTAL_BLACK} alt="Ingenious" style={{ height: 36 }}
            onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='block'; }} />
          <div style={{ display: 'none', color: '#fff', fontSize: 22, fontWeight: 700, letterSpacing: 2 }}>INGENIOUS</div>
          <p style={{ color: '#64748b', marginTop: 8, fontSize: 14 }}>Tendering Dashboard</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 6 }}>Email address</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)} required
              style={{ width: '100%', padding: '10px 14px', background: '#0f172a', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, color: '#e2e8f0', fontSize: 14, boxSizing: 'border-box', outline: 'none' }}
              placeholder="you@ingeniouspe.tech"
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', color: '#c9d1d9', fontSize: 13, marginBottom: 6 }}>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required
                style={{ width: '100%', padding: '10px 40px 10px 14px', background: '#0f172a', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, color: '#e2e8f0', fontSize: 14, boxSizing: 'border-box', outline: 'none' }}
                placeholder="••••••••"
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)}
                style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#c9d1d9', fontSize: 16, padding: 0, lineHeight: 1 }}>
                {showPassword ? '🙈' : '👁'}
              </button>
            </div>
          </div>

          {error && (
            <div style={{ background: '#7f1d1d', color: '#fca5a5', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '12px', background: loading ? '#334155' : '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: loading ? 'default' : 'pointer' }}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 16, marginBottom: 0 }}>
          <button onClick={onForgotPassword}
            style={{ background: 'none', border: 'none', color: '#60a5fa', fontSize: 13, cursor: 'pointer', textDecoration: 'underline' }}>
            Forgot your password?
          </button>
        </p>

        <p style={{ textAlign: 'center', color: '#475569', fontSize: 12, marginTop: 12 }}>
          Default password: <code style={{ color: '#94a3b8' }}>ChangeMe123!</code>
        </p>
      </div>
    </div>
  );
}
